module.exports = "pegasus_template/assets/tech/small/8.png";